<template>
  <div class="home">
    <!-- 安卓 -->
    <p class="title">小睡眠会员/声音卡/宝宝卡服务协议</p>
    <div class="block">
      <p style="text-align: left">发布时间：2021年12月01日<br/>
        生效时间：2021年12月01日<br/>
        更新时间：2023年08月24日</p>
      <p class="common-p">欢迎您使用会员/声音卡/宝宝卡订阅服务！</p>
      <p class="common-p">
        《小睡眠会员/声音卡/宝宝卡服务协议》（简称“本协议”）是您与广州心与潮信息科技有限公司（简称：心潮科技）之间关于小睡眠产品提供“会员订阅服务”和“声音卡订阅服务”以及“宝宝卡订阅服务”的法律协议。您应当在充分阅读并明确理解的前提下，遵守本协议。
      </p>
      <p class="common-p">
        如果您未满18周岁，请在法定监护人陪同下或经过法定监护人同意后再使用本服务；未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可，本协议对您及您的法定监护人产生法律约束力。
      </p>
      <p class="common-p">
        本协议为《服务协议》和《隐私政策》的特别服务条款。请在接受使用会员与声音卡订阅服务前务必审慎阅读、充分理解《服务协议》和《隐私政策》及本条款的相应内容，并选择接受或不接受。本条款未予以约定的，适用《服务协议》和《隐私政策》的约定；本协议与《服务协议》和《隐私政策》有冲突的，以本协议为准。
      </p>
    </div>
    <div class="block">
      <p class="two-title">一、会员订阅服务</p>
      <p class="common-p">
        在您领取或经付费开启会员订阅服务后，您可以在相应服务期限内持续使用小睡眠会员专属服务，包括但不限于专属助眠内容、专属闹铃、专属呼吸练习和专属产品功能等。<span style="text-decoration: underline;font-weight:bold">请您务必知悉，小睡眠会员是最高等级的权益，开通会员后可享受的服务范围已经包含声音卡和宝宝卡权益，如果您已开通小睡眠会员，则无需再开通宝宝卡或声音卡。</span>
      </p>
      <p class="common-p">
        （一）常规会员服务
      </p>
      <p class="common-p">
        小睡眠的常规会员商品包含一个月会员、三个月会员、六个月会员和十二个月会员服务。
      </p>
      <p class="common-p">
        开通一个月会员、三个月会员、六个月会员和十二个月会员后，您所获得的服务期限分别为 31 个自然日、 93 个自然日、 186 个自然日和 366 个自然日。
      </p>
      <p class="common-p">（二）会员自动续费服务</p>
      <p class="common-p">
        1. 连续包月（包季、包半年、包年）是在您同意且开启会员订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的会员订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、半年卡、年卡）服务费用。扣费规则及时间以<span @click="$router.push('/bf8290')" class="link">《小睡眠自动续费协议》</span>为准。
      </p>
      <p class="common-p">
        2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。
      </p>
      <p class="common-p">
        3. 您可通过下述途径取消已开通的连续包月（包季、包半年、包年）服务：
      </p>

      <p class="common-p">（1）苹果设备</p>
      <p class="common-p">在苹果手机或 iPad 的 “设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>

      <p class="common-p">（2）华为&荣耀系列手机</p>
      <p class="common-p">5.7.0 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">5.7.0 以下的小睡眠App版本在“我的” → 选择“会员中心” → 选择“···” → 选择“管理续费” → 关闭“小睡眠会员包月自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

      <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>

      <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
      <p class="common-p">5.7.0 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">5.7.0 以下的小睡眠App版本在“我的” → 选择“会员中心” → 选择“···” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      
      <!-- <p class="common-p">（5）vivo&其他Android系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠会员包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p> -->
     </div>
    <div class="block">
      <p class="two-title">二、声音卡订阅服务</p>
      <p class="common-p">声音卡是基于专属助眠内容定制的付费服务，在您领取或经付费开启声音卡订阅服务后，您可以在相应服务期限内持续使用小睡眠声音卡的专属内容，包括白噪音、每日梦境、舒眠放松、晚安电台、爱豆哄睡、冥想专题、奇妙播单。</p>
      <p class="common-p">（一）常规声音卡服务</p>
      <p class="common-p">小睡眠的常规声音卡商品包含一个月声音卡、三个月声音卡、六个月声音卡和十二个月声音卡服务。</p>
      <p class="common-p">开通一个月声音卡、三个月声音卡、六个月声音卡和十二个月声音卡后，您所获得的服务期限分别为 31 个自然日、 93 个自然日、 186 个自然日和 366 个自然日。</p>
      <p class="common-p">（二）声音卡自动续费服务</p>
      <p class="common-p">1. 连续包月（包季、包年）是在您同意且开启声音卡订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的声音卡订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、年卡）服务费用。扣费规则及时间以<span @click="$router.push('/bf8290')" class="link">《小睡眠自动续费协议》</span>为准。</p>
      <p class="common-p">2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。</p>
      <p class="common-p">3. 您可通过下述途径取消已开通的连续包月（包季、包年）服务：</p>
      <p class="common-p">（1）苹果设备</p>
      <p class="common-p">在苹果手机或 iPad 的“设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <p class="common-p">（2）华为&荣耀系列手机</p>
      <p class="common-p">在小睡眠App“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
      <p class="common-p">在小睡眠App“我的” → 选择“声音卡” → 选择“声音卡页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <!-- <p class="common-p">（5）vivo&其他Android系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p> -->
    </div>
    <div class="block">
      <p class="two-title">三、宝宝卡订阅服务</p>
      <p class="common-p">宝宝卡是基于母婴助眠场景定制的付费服务，在您领取或经付费开启宝宝卡订阅服务后，您可以在相应服务期限内持续使用小睡眠宝宝卡的专属内容，包括哄宝宝睡、缤纷世界、胎教音乐、疗愈音乐、减痛分娩、晚安动画。</p>
      <p class="common-p">（一）常规宝宝卡服务</p>
      <p class="common-p">小睡眠的常规宝宝卡商品包含一个月宝宝卡、三个月宝宝卡、六个月宝宝卡、十二个月宝宝卡和三年宝宝卡服务。</p>
      <p class="common-p">开通一个月宝宝卡、三个月宝宝卡、六个月宝宝卡、十二个月宝宝卡和三年宝宝卡后，您所获得的服务期限分别为 31 个自然日、 93 个自然日、 186 个自然日、 366 个自然日和 1098 个自然日。</p>
      <p class="common-p">（二）宝宝卡自动续费服务</p>
      <p class="common-p">1. 连续包月（包季、包半年、包年）是在您同意且开启宝宝卡订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的宝宝卡订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号（简称“账户”）等，代扣下一个计费周期的月卡（季卡、半年卡、年卡）服务费用。扣费规则及时间以<span @click="$router.push('/bf8290')" class="link">《小睡眠自动续费协议》</span>为准。</p>
      <p class="common-p">2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。</p>
      <p class="common-p">3. 您可通过下述途径取消已开通的连续包月（包季、包半年、包年）服务：</p>
      <p class="common-p">（1）苹果设备</p>
      <p class="common-p">在苹果手机或 iPad 的“设置” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <p class="common-p">（2）华为&荣耀系列手机</p>
      <p class="common-p">在小睡眠App“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <p class="common-p">（3）OPPO&Realme&一加系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">6.1.3 以下的在小睡眠App版本需前往第三方支付平台取消：①“支付宝” → 选择“我的页面” → 选择“设置” → 选择“支付设置”  → 选择“免密支付/自动扣款”→ 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。②“微信” → 选择“我页面” → 选择“服务” → 选择“钱包”  → 选择“支付设置”→ 选择“自动续费”→ 关闭“小睡眠宝宝卡包月（包季、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p>
      <p class="common-p">（4）小米&红米&vivo&其他Android系列手机</p>
      <p class="common-p">在小睡眠App“我的” → 选择“宝宝卡” → 选择“宝宝卡页面” → 选择“管理续费” → 关闭“小睡眠宝宝卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。</p>
      <!-- <p class="common-p">（5）vivo&其他Android系列手机</p>
      <p class="common-p">6.1.3 及以上的小睡眠App版本在“我的” → 选择“会员” → 选择“会员页面” → 选择“管理续费” → 关闭“小睡眠声音卡包月（包季、包半年、包年）自动续费” → 确认关闭。如未在计费周期到期前至少 24 小时前取消自动续费功能，将会自动续订及扣款。注：您可在“我的” → “关于小睡眠”页面查看当前版本号。</p> -->
    </div>
    <div class="block">
      <p class="two-title">四、付费服务并存说明</p>
      <p class="common-p" style="font-weight: bold" >1. 自动续费会员服务与常规会员服务并存</p>
      <p class="common-p">自动续费会员与常规会员服务出现并存的情况，将遵循自动续费的会员周期，优先使用连续包月（包季、包半年、包年）会员时长，常规会员服务时长则在原服务有效期的基础上延长。</p>
      <p class="common-p" style="font-weight: bold" >2. 自动续费声音卡服务与常规声音卡服务并存</p>
      <p class="common-p">自动续费声音卡服务与常规声音卡服务出现并存的情况，将遵循自动续费的声音卡周期，优先使用连续包月（包季、包半年、包年）声音卡时长，常规声音卡服务时长则在原服务有效期的基础上延长。</p>
      <p class="common-p" style="font-weight: bold" >3. 自动续费宝宝卡服务与常规宝宝卡服务并存</p>
      <p class="common-p">自动续费宝宝卡服务与常规宝宝卡服务出现并存的情况，将遵循自动续费的宝宝卡周期，优先使用连续包月（包季、包半年、包年）宝宝卡时长，常规宝宝卡服务时长则在原服务有效期的基础上延长。</p>
      <p class="common-p" style="font-weight: bold" >4. 宝宝卡服务、声音卡服务与会员服务并存</p>
      <p class="common-p">宝宝卡服务、声音卡服务与会员服务并存的情况，将遵循两种服务时长并行存在的规则，即分别使用宝宝卡服务、声音卡服务与会员服务各自的有效时长，并享有对应的权益。</p>
    </div>
    <div class="block">
      <p class="two-title">五、付费服务说明</p>
      <p class="common-p">（一）您理解并同意，会员/声音卡/宝宝卡订阅服务为付费服务，小睡眠将收取互联网增值服务使用费；您可以在相关服务页面查阅会员/声音卡/宝宝卡订阅服务具体期限及对应费用并自行选择服务的种类。开启会员/声音卡/宝宝卡订阅功能后，无论您是否在相应服务期限内实际使用该服务，已生效的服务费用不支持转让与退款。</p>
      <p class="common-p">（二）您理解并同意，心潮科技有权自行决定并不时修订会员/声音卡/宝宝卡订阅服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本条款的有效组成部分。如您不同意前述标准、规则及其修订，您有权停止使用会员/声音卡/宝宝卡订阅服务。您继续使用会员/声音卡/宝宝卡订阅服务即视为您同意相关内容。</p>
    </div>
    <div class="block">
      <p class="two-title">六、未成年人使用条款</p>
      <p class="common-p">（一）若您未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用付费会员服务，并且已经获得监护人之同意。</p>
      <p class="common-p">（二）若监护人同意未成年人使用会员/声音卡/宝宝卡服务，必须以监护人名义申请消费，未成年人使用付费会员/声音卡/宝宝卡服务，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。</p>
      <p class="common-p">（三）请未成年人用户注意保护个人信息，合理安排使用网络的时间，避免沉迷于网络，影响日常的学习生活。</p>
    </div>
    <div class="block">
      <p class="two-title">七、免责声明</p>
      <p class="common-p">心潮科技有权根据产品计划和运营情况独立决定会员/声音卡/宝宝卡订阅服务的具体内容，并有权根据内容的版权情况新增或移除内容或暂停、终止提供会员/声音卡/宝宝卡订阅服务的部分功能服务。前述决定不经通知即生效，您同意心潮科技对此免责。如您对上述条款有任何疑问请发送电子邮件到office@heartide.com。</p>
    </div>
    <div class="block" style="text-align: right">
      <p>广州心与潮信息科技有限公司</p>
      <p>更新时间 2023年08月24日</p>
    </div>
    </div>
</template>

<script>
export default {
  name: 'home',
  mounted () {
    document.getElementsByTagName("title")[0].innerHTML="&#65279;"
  }
}
</script>

<style lang="scss" scoped>
.home {

  p {
    font-size: 16px;
  }
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(22px);
  padding-right: px2html(22px);
  .red {
    color: red;
    text-align: left;
  }
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin: 20px 0;
  }
}
.link{
  color: blue;
  text-decoration: underline;
}
</style>
